import * as actionTypes from "./actionTypes";



export const editMapState = (mapObject) => {

  return {

    type: actionTypes.EDIT_MAP_STATE,

    payload: {

      ...mapObject,

    },

  };

};



export const editMapStateAsync = (mapObject) => (dispatch, getState) =>

  Promise.resolve().then(() => {

    return dispatch(editMapState(mapObject));

  });

//Redux thunk enabled



export const editMapPoint = (alertObject, url) => {




  return {

    type: actionTypes.EDIT_MAP_POINT,

    payload: {

      alarm: alertObject,

      iconUrl: url

    },

  };

};



export const editMapPointAsync = (

  alertObject,

  url

) => (dispatch, getState) =>

    Promise.resolve().then(() => {

      return dispatch(editMapPoint(alertObject, url));

    });

